$(function() {
    $('.instant-submit-select').change(function() {
        this.form.submit();
    });
});